
<div class="main-init">
  <PortraitPromptPanel />
  <OfflineWarningPanel />
  <BrowserWarningPanel
    v-if="showBrowserWarning"
    @close="showBrowserWarning = false"
  />
</div>
